import { register } from "async-ops";
import { callMvcApi  } from "../../../call-web-api";
import { getDefaultOptions } from "../../../utils/fetch";
export const INSERT_NEW_COMMENT_CATEGORY = 'INSERT_NEW_COMMENT_CATEGORY';


export const service = async (data) => {
  const options: object = {
    url:  '/Api/Comments/PostCommentCategory',
    method: "POST",
    ...getDefaultOptions(),
    body: JSON.stringify(data)
  }
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(INSERT_NEW_COMMENT_CATEGORY, service, mock);
